module.exports = __webpack_public_path__ + "img/vie_associative.5ca54782.png";